define('SageDotCom/Components/Commerce/Cart/MiniCart',["jquery", "knockout", "eventManager", './MiniCartViewModel'],
    function ($, ko, eventManager, miniCartViewModel) {
        
        function MiniCart(scope) {

            this.cart = null;
            var viewModel = new miniCartViewModel(this.cart);
            Object.defineProperties(this, {
                scope: {enumerable: !0, configurable: !0, writable: !1, value: scope },
                $scope: { enumerable: !1, configurable: !0, writable: !1, value: $(scope) },
                model: { enumerable: !0, configurable: !0, writable: !0, value: viewModel }
            });

            eventManager.subscribe("Sage:CartCalculated", function (data) {
                this.model.cart(data);
            }, this);

            this._attachEvents();

            ko.applyBindings(this.model, scope);
        }

        MiniCart.prototype._attachEvents = function _attachEvents() {
            var resizeTimer = null;
            var scrollTimer = null;
            // change state for button (add delete)
            $('.fr-submit', this.scope).on('click', '.score-button', function () {
                $(this).parentsUntil('.flex-item').toggleClass('block-added');
            });

            // fix cart
            $(window).scroll((function () {
                if (scrollTimer) {
                    clearTimeout(scrollTimer);
                }
                var self = this;
                scrollTimer = setTimeout(function(){
                    var scrollPos = $(window).scrollTop();
                    var winHeight = $(window).height();
                    var visibleWin = scrollPos + winHeight;
                    
                    var cartHeight = $('.fr-ultimate-offer .score-left')[0].clientHeight;
                    var cartPosition = $('.fr-ultimate-offer').position().top;

    
                    if (visibleWin > cartPosition && visibleWin <= (cartPosition + cartHeight)) {
                        self.$scope.addClass('set-fixed');
                    } else {
                        self.$scope.removeClass('set-fixed');
                    }
                },200);

            }).bind(this)); 
             
            $(window).resize(function () {
                if (resizeTimer) {
                    clearTimeout(resizeTimer);
                }
                resizeTimer = setTimeout(function(){
                    if ($(window).width() >= 768) {
                        $('.fr-ultimate-offer .fr-offer-cart').addClass('theme-light').removeClass('theme-dark');
                    } else {
                        $('.fr-ultimate-offer .fr-offer-cart').removeClass('theme-light').addClass('theme-dark');
                    }
                },200);
            });          
        }

        MiniCart.init = function init(args) {
            return args.IsEditorEditing ? null : new MiniCart(args.scope);
        }

        return MiniCart;
    });


